export const MAERSK_FONT_FAMILY = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

export const INITIAL_SUCCESS_RATE = { success: 0, failure: 0, ongoing: 0, total: 0 };
export const INITIAL_OVERDUE_CHANGES = { overdue: 0, total: 0 };
export const INITIAL_CONFLICTING_CHANGES = { conflicts: 0, total: 0 };
export const INITIAL_INCIDENTS = { p1: 0, p2: 0, p3: 0, p4: 0, total: 0 };
export const INITIAL_USER_DETAILS = {
  applications: [],
  subscribedApplications: [],
  subscribedViaListApplications: {},
  platforms: [],
  portfolios: [],
  applicationsCount: 0,
  platformsCount: 0,
  portfoliosCount: 0
};

export const CHART_COLORS = ['#003E62', '#42B0D5', '#A1D1E8', '#E2F3FB'];
export const TAB_LABELS = ['SNOW Changes', 'CI/CD Changes'];
export const TIME_FILTER_OPTIONS = ['ongoing', 'past', 'future'];
export const APPLICATION_VIEW_LABELS = {
  consolidated: 'All Applications',
  owned: 'My Applications',
  subscribed: 'Subscribed Applications'
};
